import { render, staticRenderFns } from "./quiz-questions-component-new.vue?vue&type=template&id=f5826782&scoped=true&"
import script from "./quiz-questions-component-new.vue?vue&type=script&lang=ts&"
export * from "./quiz-questions-component-new.vue?vue&type=script&lang=ts&"
import style0 from "./quiz-questions-component-new.vue?vue&type=style&index=0&id=f5826782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5826782",
  null
  
)

export default component.exports